// Module
var code = "<div aria-label=\"[[ this.trans('infobox-element') ]]\" alt=\"[[ this.trans('infobox-element') ]]\" title=\"[[ this.trans('infobox-element') ]]\" class=\"my-12 md:my-16\"> <div class=\"w-20 h-2.5 bg-yellow mb-3\"></div> <div view=\"Html\" data-html=\"[[ info ]]\" class=\"infobox-content text-xl text-grey_4\">[[info]]</div> </div> ";
// Exports
export default code;